export const THEMES = {
  DEFAULT: "DEFAULT",
};
